import { createSlice } from "@reduxjs/toolkit";

const items = localStorage.getItem('cartList') !=null ? JSON.parse(localStorage.getItem('cartList')) : []
const productQuantity = localStorage.getItem('bagListQuantity') !=null ? JSON.parse(localStorage.getItem('bagListQuantity')) : [];
const initialState = {
    cartList:items,
    bagListQuantity:productQuantity,
}

const bagSlice = createSlice({
    name: 'bag',
    initialState,
    reducers: {
        addToBag: (state, action) => {  
            state.cartList.push(action.payload)
            localStorage.setItem('cartList',JSON.stringify(state.cartList.map(item=>item)))
            
            if(localStorage.getItem('bagListQuantity')===null){
                state.bagListQuantity.push({id:action.payload, quantity:1})
                localStorage.setItem('bagListQuantity',JSON.stringify(state.bagListQuantity))
                
            } else {
                const productQuantities = JSON.parse(localStorage.getItem('bagListQuantity'));
                let productQty = productQuantities.find((el) => el.id === action.payload); 
                if(productQty===undefined){
                    state.bagListQuantity.push({id:action.payload, quantity:1})
                    localStorage.setItem('bagListQuantity',JSON.stringify(state.bagListQuantity))
                } else{
                        state.bagListQuantity = state.bagListQuantity.map((el)=> {
                            if(el.id===action.payload){
                                return {...el, quantity:1}
                            }
                            return el
                        });
                        localStorage.setItem('bagListQuantity',JSON.stringify(state.bagListQuantity))
                    }
            }
            
        },
        removeFromBag: (state, action) => {             
            //return state.cartList.filter(itemId => itemId !== action.payload)
            state.cartList = state.cartList.filter(itemId => itemId !== action.payload)            
            localStorage.setItem('cartList', JSON.stringify(state.cartList)) 
            // state.bagListQuantity = state.bagListQuantity.map((el)=> {
            //     if(el.id===action.payload){
            //         return {...el, quantity:1}
            //     }
            //     return el
            // });            
            // localStorage.setItem('bagListQuantity', JSON.stringify(state.bagListQuantity))             
        },
        addQuantity: (state, action) => { 
            state.bagListQuantity = state.bagListQuantity.map((el)=> {
                if(el.id===action.payload.id){
                    return {...el, quantity:action.payload.quantity+1}
                }
                return el
            });            
            //console.log(state.bagListQuantity);
            localStorage.setItem('bagListQuantity',JSON.stringify(state.bagListQuantity))
            
        },
        subQuantity: (state, action) => {
            state.bagListQuantity = state.bagListQuantity.map((el)=> {
                if(el.id===action.payload.id){
                    return {...el, quantity:action.payload.quantity-1}
                }
                return el
            });            
            //console.log(state.bagListQuantity);
            localStorage.setItem('bagListQuantity',JSON.stringify(state.bagListQuantity))
        },
    }
});

export const bagActions = bagSlice.actions;
export default bagSlice;